module.exports = __webpack_public_path__ + "static/media/20210411_151737_114_IMG_0472.4b571052.jpg";